import React, { createContext, useContext, useState } from "react";
import { getSketchDesignProjectsWithApprovalsByUser } from "../api/projectApi";
import { getSketchDesignApproval } from "../api/projectEstimatesApi";

const PendingSketchDesignApprovalsContext = createContext();

export function PendingSketchDesignApprovalsProvider({ children }) {
  const [pendingSketchDesignApprovalsCount, setPendingSketchDesignApprovalsCount] =
    useState(0);

  const updatePendingSketchDesignApprovalsCount = async (userData) => {
    if (!userData?.id) {
      setPendingSketchDesignApprovalsCount(0);
      return;
    }

    try {
      const projects = await getSketchDesignProjectsWithApprovalsByUser();
      if (!projects?.length) {
        setPendingSketchDesignApprovalsCount(0);
        return;
      }

      const BATCH_SIZE = 8;
      let pendingCount = 0;

      for (let i = 0; i < projects.length; i += BATCH_SIZE) {
        const batch = projects.slice(i, i + BATCH_SIZE);
        const batchCalls = batch.flatMap((project) => [
          getSketchDesignApproval(project.id, "commercial_offer"),
          getSketchDesignApproval(project.id, "estimate"),
        ]);
        const approvals = await Promise.all(batchCalls);

        approvals.forEach((approval) => {
          const myApprover = approval?.approvers?.find(
            (approver) =>
              Number(approver?.user?.id) === Number(userData.id) ||
              Number(approver?.user_id) === Number(userData.id),
          );

          if (!myApprover) return;

          const status = String(myApprover.status || "").toLowerCase();
          const isPending =
            !status ||
            status === "in_processing" ||
            status === "pending" ||
            status === "на рассмотрении";

          if (isPending) {
            pendingCount += 1;
          }
        });
      }

      setPendingSketchDesignApprovalsCount(pendingCount);
    } catch (error) {
      console.debug("Нет согласований проектов ЭП в ожидании");
      setPendingSketchDesignApprovalsCount(0);
    }
  };

  return (
    <PendingSketchDesignApprovalsContext.Provider
      value={{
        pendingSketchDesignApprovalsCount,
        updatePendingSketchDesignApprovalsCount,
      }}
    >
      {children}
    </PendingSketchDesignApprovalsContext.Provider>
  );
}

export const usePendingSketchDesignApprovals = () =>
  useContext(PendingSketchDesignApprovalsContext);
